function NotAuthorizedPage() {
    return (    
        <div className="msds-text-lead msds-text-clear-blue text-center">
            You don't have access to see this page.
        </div>        
    );
}

export default NotAuthorizedPage;
